import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type OrderEaseConnectionStatusFieldsFragment = { __typename?: 'OrderEaseConnectionStatus', connected: boolean, connectedAt?: Types.TDateISO | null, maskedClientKey?: string | null };

export type OrderEaseIntegrationQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type OrderEaseIntegrationQuery = { __typename?: 'Query', orderEaseIntegration: { __typename?: 'OrderEaseConnectionStatus', connected: boolean, connectedAt?: Types.TDateISO | null, maskedClientKey?: string | null } };

export const OrderEaseConnectionStatusFieldsFragmentDoc = new TypedDocumentString(`
    fragment OrderEaseConnectionStatusFields on OrderEaseConnectionStatus {
  connected
  connectedAt
  maskedClientKey
}
    `, {"fragmentName":"OrderEaseConnectionStatusFields"});
export const OrderEaseIntegrationDocument = new TypedDocumentString(`
    query OrderEaseIntegration {
  orderEaseIntegration {
    ...OrderEaseConnectionStatusFields
  }
}
    fragment OrderEaseConnectionStatusFields on OrderEaseConnectionStatus {
  connected
  connectedAt
  maskedClientKey
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    OrderEaseIntegration: build.query<OrderEaseIntegrationQuery, OrderEaseIntegrationQueryVariables | void>({
      query: (variables) => ({ document: OrderEaseIntegrationDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useOrderEaseIntegrationQuery, useLazyOrderEaseIntegrationQuery } = injectedRtkApi;
